// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"why-module--wrapper--3rikY","image":"why-module--image--1C54A"};